import { AuthState, OktaAuthCoreInterface } from '@okta/okta-auth-js';
import { TokenType } from '../types';
import { TokenAuthentication } from './service';

export const authenticationStateFromTokenService = (
  _authState: AuthState,
  error?: any,
): AuthState => ({
  isAuthenticated: TokenAuthentication.exists(),
  error,
});

export const transformOktaAuthenticationState = async (
  oktaAuth: OktaAuthCoreInterface,
  state: AuthState,
) => {
  const authenticated = TokenAuthentication.exists();

  if (
    !authenticated &&
    state.accessToken != null &&
    oktaAuth.options.clientId != null
  ) {
    try {
      await TokenAuthentication.create(
        state.accessToken.accessToken,
        TokenType.Okta,
        oktaAuth.options.clientId,
      );
    } catch (error) {
      return authenticationStateFromTokenService(state, error);
    }
  }

  return authenticationStateFromTokenService(state);
};
